import { RootState } from 'redux/store'
import { SuitabilityCode } from 'models/administration'
import { BackendLoading } from 'redux/redux.shared'

export const selectFilesDefaultSuitabilityCode = (state: RootState): SuitabilityCode | null | undefined =>
  state.files.suitability.defaultSuitabilityCode
export const selectFetchingFilesDefaultSuitabilityCodeLoading = (state: RootState): BackendLoading =>
  state.files.suitability.loading.fetchDefaultSuitabilityCode
